import request from '@/utils/request'

let CodeBatchApi = {
 /*批次列表*/
 batchlist(data, errorback) {
  return request._post('/shop/plus.codebatch.codebatch/index', data, errorback);
},
 /*批次编码列表*/
 codelist(data, errorback) {
  return request._post('/shop/plus.codebatch.code/index', data, errorback);
},
/*获取详情*/
getDetail(data, errorback) {
  return request._get('/shop/plus.codebatch.codebatch/add', data, errorback);
},
/*添加批次*/
addBacth(data, errorback) {
  return request._post('/shop/plus.codebatch.codebatch/add', data, errorback);
},
/*查询二维码*/
findPosterCode(data, errorback) {
  return request._post('/shop/plus.codebatch.code/getPoster', data, errorback);
},
/*获取编码批次列表*/
getCodeList(data, errorback) {
  return request._post('/shop/plus.codebatch.codebatch/getCodeBatchList', data, errorback);
},
/*批量导出编码*/
exportCode(data, errorback) {
  return request._post('/shop/plus.codebatch.codebatch/exportCode', data, errorback);
},
}
export default CodeBatchApi;



// WEBPACK FOOTER //
// ./src/api/codebatch.js